module.exports = __webpack_public_path__ + "img/jameson-main-bg.9b552448.jpg";